import { useContent } from '@/hooks/useContent';
import { Container, WwProse } from '@/components';

export const AwarenessPage = () => {
  const { awareness } = useContent();
  if (!awareness) return null;

  return (
    <Container max={820}>
      <div className="ww-eyebrow" style={{ color: 'var(--ww-orange)' }}>
        Achtsam feiern
      </div>
      <h1 className="mb-8 mt-2 font-disp text-5xl uppercase text-ww-charcoal sm:text-6xl">
        AWARENESS
      </h1>
      <WwProse html={awareness} />
    </Container>
  );
};
